<template>
  <div class="van-tabs-content item1">
    <div class="item1-content-box" v-for="(item, date) in list" :key="index">
      <div class="day-style">{{ date }}</div>
      <div class="item1-content-card" v-for="(item1, idx) in item" :key="'card' + idx">
        <div class="time-identity">
          <div class="time">{{ checkTime(item1.startTime, item1.endTime) }}</div>
          <div class="identity" :class="identityMap[item1.identityCodeNameCn]">
            <div>
              {{ $t1(item1, 'identityCodeName') }}
            </div>
          </div>
        </div>
        <div class="card">
          <div class="title">{{ $t1(item1, 'name') }}</div>
          <div class="address">{{ $t1(item1, 'placeName') }}</div>
          <div class="position" v-if="item1.seat">{{ item1.seat }}</div>
        </div>
        <div class="left-style">
          <div class="circular"></div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityJoin } from "@/api/activity";
export default {
  name: "infoItem1",
  data() {
    return {
      identityMap: {
        主持人: 'green',
        讨论嘉宾: 'yellow',
        参会嘉宾: 'blue',
        发言嘉宾: 'orange'
      },
      list: {}
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getActivityJoin()
    },
    getActivityJoin() {
      getActivityJoin().then(res => {
        this.list = res.data
      })
    },
    checkTime(startTime, endTime) {
      if (!startTime || !endTime) {
        return ''
      }
      return startTime.substring(0, 5) + '-' + endTime.substring(0, 5)
    }
  }
};
</script>

<style lang="scss" scoped>
.van-tabs-content {
  margin: 20px 0 0;

  &.item1 {
    .item1-content-box {
      position: relative;
      margin: 0 0 25px;

      .day-style {
        margin: 0 0 2px;
        width: 107px;
        height: 38px;
        padding-left: 10px;
        background: url("~@/assets/img/day_bg.png") no-repeat;
        background-size: contain;
        box-sizing: border-box;
        font-size: 15px;
        font-family: GalanoGrotesqueDEMO-Bold, GalanoGrotesqueDEMO;
        font-weight: bold;
        color: #ffffff;
        line-height: 20px;
        text-align: left;
      }

      .item1-content-card {
        position: relative;
        padding-left: 20px;
        padding-bottom: 15px;

        &:last-child {
          .left-style .line {
            display: none;
          }
        }

        .time-identity {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin: 0 0 8px;

          .time {
            font-size: 14px;
            font-family: Helvetica;
            color: #ffffff;
            line-height: 17px;
          }

          .identity {
            margin-left: 8px;
            // height: 16px;
            border-radius: 2px;
            padding: 3px 4px;
            font-size: 10px;
            font-weight: 500;
            color: #ffffff;
            line-height: 1;
            box-sizing: border-box;

            // div {
            //   transform: scale(0.83);
            // }

            &.green {
              background: linear-gradient(235deg, #48c33e 0%, #2c8f23 100%);
            }

            &.blue {
              background: linear-gradient(141deg, #0f4ac2 0%, #5d83d8 100%);
            }

            &.orange {
              background: linear-gradient(141deg, #fd584b 0%, #f68a45 100%);
            }

            &.yellow {
              background: linear-gradient(141deg, #e5b57d 0%, #fde5ce 100%);
            }
          }
        }

        .card {
          padding: 15px;
          border-radius: 4px 0px 0px 4px;
          background: linear-gradient(270deg,
              rgba(94, 113, 215, 0) 0%,
              #303dae 100%);
          border-image: linear-gradient(270deg,
              rgba(69, 132, 199, 0),
              rgba(71, 137, 199, 0.4)) 1 1;
          text-align: left;

          .title {
            margin: 0 0 8px;
            font-size: 15px;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
          }

          .address,
          .position {
            position: relative;
            padding-left: 21px;
            font-size: 13px;
            font-weight: 400;
            color: rgba($color: #fff, $alpha: 0.6);
            line-height: 19px;
          }

          .address::before,
          .position::before {
            content: "";
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            width: 16px;
            height: 16px;
          }

          .address::before {
            background: url("~@/assets/img/address_icon.png");
            background-size: contain;
          }

          .position::before {
            background: url("~@/assets/img/position_icon.png");
            background-size: contain;
          }

          .position {
            margin: 5px 0 0;
          }
        }

        .left-style {
          position: absolute;
          left: 0;
          top: 0px;
          bottom: 0;

          .circular {
            position: relative;
            width: 14px;
            height: 14px;
            background: url("~@/assets/img/ic_circular_green.png") center no-repeat;
            background-size: contain;
          }

          .line {
            width: 1px;
            margin: 8px auto 0;
            height: calc(100% - 22px);
            background-image: linear-gradient(to bottom,
                #3eb134 0%,
                #3eb134 10%,
                transparent 20%);
            background-size: 1px 10px;
            background-repeat: y-repeat;
          }
        }
      }
    }
  }
}
</style>
